import {Component, ElementRef, ViewChild} from '@angular/core';
import { IonContent } from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import { DialogsService, DialogStats } from 'app/dialogs';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

import { NavService } from 'shared/nav/nav.service';

@Component({
  selector: 'monitoring-page',
  templateUrl: 'monitoring-page.html',
  styleUrls: ['monitoring-page.scss'],
})
export class MonitoringPage extends DefaultPage {

  public isLoading: boolean = true;

  public dialogStats: DialogStats;
  public levelName: string = '';

  constructor(
    public navService: NavService,
    public translateService: TranslateService,
    public dialogsService: DialogsService,

  ) {
    super(navService);
  }

  private ionViewWillEnter(): void {
    this.isLoading = true;
    this.load();
  }

  private load() {
    this.dialogsService.getDialogsStats()
    .subscribe((stats: DialogStats) => {
      console.log(stats);
      this.dialogStats = stats;
      this.isLoading = false;
      this.levelName = this.translateService.instant('MONITORING.LEVEL.LONG.'+stats.level);
    });
  }

  public calcRel(cntGroup: number, nGroup: number): string {
    if (cntGroup == 0 || nGroup == 0) {
      return '';
    }
    const valGroup = cntGroup / nGroup;
    return valGroup.toFixed(1);
  }
}
